export default "__VITE_ASSET__BCZaHFbz__"